var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10833_745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8847 23.4615C18.0023 23.4615 22.9616 18.5021 22.9616 12.3845C22.9616 6.26692 18.0023 1.30762 11.8847 1.30762C5.76704 1.30762 0.807739 6.26692 0.807739 12.3845C0.807739 18.5021 5.76704 23.4615 11.8847 23.4615Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8847 16.077C14.4337 16.077 16.5001 14.0106 16.5001 11.4616C16.5001 8.91257 14.4337 6.84619 11.8847 6.84619C9.33569 6.84619 7.26929 8.91257 7.26929 11.4616C7.26929 14.0106 9.33569 16.077 11.8847 16.077Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.47693 20.6231C5.17144 19.2551 6.23119 18.1062 7.53871 17.3036C8.84623 16.5011 10.3504 16.0762 11.8847 16.0762C13.4188 16.0762 14.9231 16.5011 16.2305 17.3036C17.538 18.1062 18.5978 19.2551 19.2923 20.6231",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10833_745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBlue);
export default __webpack_public_path__ + "static/media/login_blue.c5edc65c029bb32697cc3dafc48fa8b2.svg";
export { ForwardRef as ReactComponent };